import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'

interface exportDataProps {
  filter: any
  setIsExportRequestLoading: Function
  setShowOverlay: Function
}

const exportData = async (props: exportDataProps) => {
  let response: any = false

  const formData = {
    ...props.filter,
  }

  props.setIsExportRequestLoading(true)
  response = await axiosPost(
    apiUrls.devices + '/' + apiUrls.actionExport,
    formData,
    (err: AxiosError) => {
      displayGenError({ setShowOverlay: props.setShowOverlay })
      props.setIsExportRequestLoading(false)
    },
    false,
    {
      responseType: 'blob',
    },
  ).then((response) => {
    // create file link in browser's memory
    const href = URL.createObjectURL(response.data)
    // create "a" HTML element with href to file & click
    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', 'devices-export.xlsx') //or any other extension
    document.body.appendChild(link)
    link.click()

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
    props.setIsExportRequestLoading(false)
  })

  return response
}

export default exportData
